<template>
  <v-container>
    <v-row>
      <v-col cols="6">
        <v-img src="https://i.imgur.com/aKJNoOs.jpg" max-height="80vh" contain></v-img>
      </v-col>
      <v-col cols="6">
        <div class="text-h2">A Special Thanks!</div>
        <div class="text-h4">Fap Interactive is provided free of charge and advertisements thanks to our lovely patrons over at patreon.</div>
        <v-btn color="warning" rounded href='https://www.patreon.com/bePatron?u=36618477' target="_blank">
          Become a Patron
        </v-btn>
        <v-row class="space-between">
          <v-col cols="4">
            <v-card
              class="mx-auto"
              max-width="300"
              tile
            >
              <v-list dense disabled>
                <v-subheader>Supporters($1/mo)</v-subheader>
                <v-list-item-group>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>Your Name Here</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
          </v-col>
          <v-col cols="4">
            <v-card
              class="mx-auto"
              max-width="300"
              tile
            >
              <v-list dense disabled>
                <v-subheader>Representatives($3/mo)</v-subheader>
                <v-list-item-group>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>Your Name Here</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
          </v-col>
          <v-col cols="4">
            <v-card
              class="mx-auto"
              max-width="300"
              tile
            >
              <v-list dense disabled>
                <v-subheader>Beta Testers($5/mo)</v-subheader>
                <v-list-item-group>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>Your Name Here</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

    export default {
      name: 'underConstruction',
      data: () => ({

      }),
      methods: {

      },
    }
</script>